export const data = [

    {
        category: 'proj',
        title: " Facebook Pytorch scholarship Program in Udacity : making hands dirty with cools Deep learning projects",
        tools: "pytorch - python - nlp - ... ",
        date: "12/19 to 02/20",

    },
    {
        category: 'web',
        title: " website",
        tools: "Angular - .Net Entity framework - Visual Code ",
        date: "jun 2020",

    },
    {
        category: 'web',
        title: " car panel detection",
        tools: "python - opencv ",
        date: "mars 2019",

    },
    {
        category: 'proj',
        title: " Making first portfolio",
        tools: "ReactJS - CSS",
        date: "Mars 2020",

    }, {
        category: 'web',
        title: " Covid App tracker",
        tools: "ReactJS - CSS - rest api",
        date: "Mars 2020",

    }, {
        category: 'app',
        title: " car booking app",
        tools: "andoid - firebase - gelocalization api",
        date: "Mars 2020",

    }, {
        category: 'proj',
        title: " AI for medical diagnosis projects",
        tools: "python , tensorflow , image processing , nlp",
        date: "from may 2020 ",

    },  
    {
        category: 'web',
        title: "chatbot ",
        tools: " Ntlk - Flask - Pycharm - dialogflow api",
        date: "may 2020 ",

    },
    
   
    {
        category: 'proj',
        title: "Calculator App",
        tools: "HTML - CSS - Javascript",
        date: "A.U 2016- 2017"
    },
    {
        category: 'proj',
        title: "Calculator app",
        tools: "C# ",
        date: "A.U 2016- 2017"
    },
    {
        category: 'proj',
        title: "calculator app",
        tools: "Android studio - xml ",
        date: "A.U 2016- 2017"
    }
    ,

    {
        category: 'design',
        title: "Graphic design",
        tools: "Adobe photoshop",
        date: " 2016- 2018"
    },

    {
        category: 'app',
        title: "IMC Calculator ",
        tools: "Android , java",
        date: " A.U 2016- 2017"
    },


    {
        category: 'website',
        title: "E-commerce website ",
        tools: "prestashop - php - mysql",
        date: " A.U 2017-2018"
    },

    {
        category: 'SAP',
        title: "Student management system  ",
        tools: "JavaFX - mysql driver - html -css",
        date: " A.U 2017-2018"
    }
    ,

    {
        category: 'SAP',
        title: "Library management system  ",
        tools: "JavaFX - mysql driver - html -css",
        date: " A.U 2016- 2017"
    }
    ,

    {
        category: 'SAP',
        title: "School management system  ",
        tools: "Node / Angular6 / BOOTSTRAP /mongoDB  ",
        date: " A.U 2016- 2017"
    },


    {
        category: 'website',
        title: "Chat webApp  ",
        tools: "( Socket-io - MongoDb - Express - angular - Node -HTML - CSS )",
        date: " A.U 2016- 2017"
    },



    {
        category: 'proj',
        title: "Quotes application ",
        tools: "Cordova /Javascript/ JQuery / HTML 5 /CSS/ API REST",
        date: " A.U 2016- 2017"
    },

    {
        category: 'SAP',
        title: "Student management system ",
        tools: "Node / Angular6 / BOOTSTRAP /mongoDB",
        date: " A.U 2016- 2017"
    },

    {
        category: 'proj',
        title: "Personal blog ",
        tools: "Cordova /Javascript/ JQuery / HTML 5 /CSS)",
        date: " A.U 2017-2018"
    }
    ,
    {


        category: 'app',
        title: "Chat app",
        tools: "NPM- Ionic- Angular–firebase – CSS )",
        date: "A.U 2017-2018"
    }
    ,
    {


        category: 'app',
        title: "Text extractor using Machine learning :",
        tools: " Tesseract OCR – TesseractJS – Ionic – ElectronJS - Npm – GCP api – Azure Vision API )",
        date: " A.U 2018-2019"
    },
    {


        category: 'SAP',
        title: "Manufacturing model with odoo ",
        tools: " odoo - python - postgreSQL",
        date: " A.U 2018-2019"
    }
    ,
    {


        category: 'website',
        title: "Building a social website ",
        tools: "  Django / HTML –CSS / sqlite / bootstrap",
        date: " A.U 2018-2019"
    }

    ,
    {


        category: 'SAP',
        title: "Employee management dashboard",
        tools: " FLASK -  Bootstarp - PYTHON - Sqlite",
        date: " A.U 2018-2019"
    }

    ,
    {


        category: 'SAP',
        title: "Student management system ",
        tools: " Node / AngularCLI / Uikit /Firebase",
        date: " A.U 2018-2019"
    },
    {


        category: 'proj',
        title: "Data extraction/ transcription from image - voice ",
        tools: " GCP API - Node - vscode - Python",
        date: " A.U 2018-2019"
    },
    {


        category: 'website',
        title: "Pointing system based face recognition ",
        tools: " Django - Bootstarp - HTML5 - CSS - PYTHON - Sqlite - OpenCV",
        date: " A.U 2018-2019"
    }

    ,
    {


        category: 'SAP',
        title: "HR SYSTEM",
        tools: " Java jee - angular - mysql - jPA",
        date: " A.U 2017-2018"
    }



];



// WEBPACK FOOTER //
// ./src/components/data/WorksData2.js